module.exports = __webpack_public_path__ + "static/media/doughnut.2fabc4b7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/images/doughnut.jpeg
// module id = 555
// module chunks = 0